const Inputs = ({brands, setSelectedBrand, mortarGap, setMortarGap, selectedBrick, setSelectBrick, onlyStandardBricks, database, wallDimensions, isMobile, setWallDimensions, brickStats, doorWidth, setDoorWidth, doorPosX, setDoorPosX}) => 
{
  const handleDimensionChange = (e) => 
  {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;
    const roundedValue = Math.max(0.05, Math.round(numericValue * 20) / 20);
    setWallDimensions(prev => ({
      ...prev,
      [name]: roundedValue
    }));
  };

  const handleMortarGapChange = (e) =>
  {
    const value = parseFloat(e.target.value) || 0;
    // Redondear al múltiplo de 0.5 más cercano
    const roundedValue = Math.round(value * 2) / 2;
    // Asegurar que esté entre 0.5 y 5 cm
    const clampedValue = Math.max(e.target.min, Math.min(e.target.max, roundedValue));
    setMortarGap(clampedValue);
  };

  const roundTo4 = (num) => Math.round(num * 10000) / 10000;

  const handleDoorWidthChange = (e) =>
  {

    const value = parseFloat(e.target.value) || 0;
    // Redondear al múltiplo de 0.5 más cercano
    
    const roundedValue = roundTo4(value);
    // Asegurar que esté entre 0.5 y 2 m
    const clampedValue = Math.max(e.target.min, Math.min(e.target.max, roundedValue));
    setDoorWidth(clampedValue);
  };

  const handleDoorPosX = (e) =>
  {
    const value = parseFloat(e.target.value) || 0;
    // Redondear al múltiplo de 0.5 más cercano    
    const roundedValue = roundTo4(value);
    // Asegurar que esté entre 0.5 y 2 m
    const clampedValue = Math.max(e.target.min, Math.min(e.target.max, roundedValue));
    setDoorPosX(clampedValue);

  };

  if(!database) return null; 

  return (
    <div className = "flex flex-col p-4 bg-gray-200 overflow-y-auto z-50 sm:w-3/12 sm:min-w-[300px] sm:h-full h-1/2">          

      <h2 className = "text-xl font-semibold mb-4 text-center uppercase">Parámetros de la Pared</h2>

      <div className="space-y-4">
            
        {['length', 'height'].map((dim) => (
          <div key={dim}>
            <label className="block text-sm font-medium text-gray-700">
              {dim === 'length' ? `Longitud${ isMobile ? ` - ${wallDimensions[dim]}` : ''}` : `Altura${ isMobile ? ` - ${wallDimensions[dim]}` : ''}`} (m)
            </label>
            
            <input
              type = { isMobile ? "range" : "number"}
              inputMode ="decimal"
              pattern = "[0-9]*"
              name = {dim}
              value = {wallDimensions[dim]}
              onChange = {(e) => handleDimensionChange(e)}
              className = "mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
              min = "1"
              max = { dim === 'length' ? isMobile ? 10 : 20 : isMobile ? 5 : 10 }
              step = "0.05"
            />
            
            <p className="text-xs text-gray-500">{`Incrementos de 5 cm (mínimo 1 metro - máximo ${dim === 'length' ? isMobile ? 10 : 20 : isMobile ? 5 : 10}) metros`}</p>
          </div>
        ))}

        <div>
          <label className="block text-sm font-medium text-gray-700">
            {`Espesor de mortero${ isMobile ? ` - ${mortarGap}` : ''} (cm)`}
          </label>

          <input
            type = { isMobile ? "range" : "number"}
            inputMode = "decimal"
            pattern = "[0-9]*"
            value = {mortarGap}
            onChange = {handleMortarGapChange}
            className = "mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
            min = "1"
            max = "5"
            step = "0.5"
          />
          
          <p className="text-xs text-gray-500">Incrementos de 0.5 cm (mínimo 1 cm, máximo 5 cm)</p>
        </div>

      </div>

      <h2 className = "text-xl font-semibold mb-4 text-center uppercase">Parámetros de la Abertura</h2>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          {`Ancho de la Puerta (m)`}
        </label>

        <input
          type = { isMobile ? "range" : "number"}
          inputMode = "decimal"
          pattern = "[0-9]*"
          value = {doorWidth}
          onChange = {handleDoorWidthChange}
          className = "mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
          min = ".5"
          max = "2"
          step = "0.05"
        />
        
        <p className="text-xs text-gray-500">Incrementos de 5 cm (mínimo 50 cm, máximo 2 m)</p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          {`Posición de la Puerta desde el lado izquierdo (m)`}
        </label>

        <input
          type = { isMobile ? "range" : "number"}
          inputMode = "decimal"
          pattern = "[0-9]*"
          value = {doorPosX}
          onChange = {handleDoorPosX}
          className = "mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
          min = "0"
          max = "10"
          step = "0.05"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 pt-3">Seleccionar Marca De Ladrillos</label>
        <select
          className = "mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border uppercase"
          value = {selectedBrick.id}
          onChange = {(e) => setSelectedBrand(e.target.value)}
        >
          {Object.keys(brands).map(brand => (
            <option key = {brand} value={brand} className = "uppercase">{brand}</option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 pt-3">Seleccionar Ladrillo</label>
        <select
          className = "mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
          value = {selectedBrick.id}
          onChange = {(e) => setSelectBrick(database.find(b => b.id === e.target.value))}
        >
          {onlyStandardBricks.map(block => (
            <option key = {block.id} value={block.id}>{block.brand} - {block.name}</option>
          ))}
        </select>
      </div>

      <h3 className = "text-xl font-semibold font-mono mt-3 mb-1 text-center uppercase">Resultados</h3>

      <h4 className = "text-base font-semibold font-mono my-1 text-center uppercase">cantidades</h4>

      <div className="flex justify-between mb-2">
        <span>Volumen total de mortero:</span>
        <span className="font-bold">{brickStats.totalMortarVolume} m³</span>
      </div>
      
      <div className="flex justify-between mb-2">
        <span>Ladrillos completos:</span>
        <span className="font-bold">{brickStats.brickCounts.fullBricks}</span>
      </div>
      
      <div className="flex justify-between mb-2">
        <span>Medios ladrillos completos:</span>
        <span className="font-bold">{brickStats.brickCounts.halfBricks}</span>
      </div>
      
      <div className="mt-4">
        <h5 className="font-bold mb-2">Ladrillos incompletos:</h5>
        {brickStats.brickCounts.customBricks.map((group, index) => (
          <div key={index} className="mb-3 p-3 bg-white rounded shadow-sm">
            <div className="space-y-1 text-sm">
              <div className="flex justify-between">
                <span>Cantidad:</span>
                <span className="font-bold">{group.count}</span>
              </div>
              <div className="flex justify-between">
                <span>Dimensiones:</span>
                <span className="font-bold">{group.dimensions.thickness} × {group.dimensions.height} × {group.dimensions.length} cm</span>
              </div>
              <div className="flex justify-between">
                <span>Tipo:</span>
                <span className="font-bold">{group.dimensions.type}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <h4 className = "text-base font-semibold font-mono my-1 text-center uppercase">cargas</h4>

      <div className="flex justify-between mb-2">
        <span>Peso Total:</span>
        <span className="font-bold">{brickStats.totalWeight} Kg</span>
      </div>

      <div className="flex justify-between mb-2">
        <span>Carga Lineal:</span>
        <span className="font-bold">{brickStats.linearWeight} Kg/m</span>
      </div>

      <h4 className = "text-base font-semibold font-mono my-1 text-center uppercase">costos</h4>

      <div className="flex justify-between mb-2">
        <span>Costo Mortero:</span>
        <span className="font-bold">{brickStats.mortarCost} $</span>
      </div>

      <div className="flex justify-between mb-2">
        <span>Costo Ladrillo:</span>
        <span className="font-bold">{brickStats.bricksCost} $</span>
      </div>

      <div className="flex justify-between mb-2">
        <span>Costo Total Materiales:</span>
        <span className="font-bold">{Math.round((brickStats.mortarCost + brickStats.bricksCost) * 100) / 100} $</span>
      </div>

    </div>
  )
};

export default Inputs;